import { render, staticRenderFns } from "./mj-button.vue?vue&type=template&id=8718499c&scoped=true"
import script from "./mj-button.vue?vue&type=script&lang=ts"
export * from "./mj-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8718499c",
  null
  
)

export default component.exports